import { render } from "./BasicInformation.vue?vue&type=template&id=d2271c42"
import script from "./BasicInformation.vue?vue&type=script&lang=ts"
export * from "./BasicInformation.vue?vue&type=script&lang=ts"
script.render = render

export default script